import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { hasThreatIntelV2Access } from 'garaje/utils/threat-intel-access';

export interface ThreatIntelV2EnabledSignature {
  Args: {
    Positional: [];
  };
  Return: boolean;
}

/**
 * Template-side wrapper for `hasThreatIntelV2Access`. Use this rather than reassembling the
 * composite inline so the sidebar and the render-time decision can't drift.
 *
 * Usage: {{#if (threat-intel-v2-enabled)}} Threat intelligence {{else}} Threat dashboard {{/if}}
 */
export default class ThreatIntelV2Enabled extends Helper<ThreatIntelV2EnabledSignature> {
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  compute(): ThreatIntelV2EnabledSignature['Return'] {
    return hasThreatIntelV2Access(this.featureFlags, this.state);
  }
}
